"use client";

import React from "react";
import { Microscope, Activity, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const protocolSteps = [{
  title: "Measure",
  icon: Microscope,
  description: "We Measure microbiome health, digestion, and metabolic function,"
}, {
  title: "Optimize",
  icon: Activity,
  description: "then Optimize with targeted therapies and nutrition strategies to reduce inflammation, improve absorption, and support overall performance."
}, {
  title: "Maintain",
  icon: ShieldCheck,
  description: "Maintained through ongoing gut and metabolic support."
}];
export default function MMetabolicGutOptimization() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="m-metabolic-gut-optimization" className="bg-background">
      <div className="bg-card py-[128px] px-6 md:px-12 lg:px-8">
        <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="text-center mb-20">
            <h2 className="text-6xl md:text-8xl font-light text-foreground font-default mb-8 tracking-[0.4em] ml-[0.4em]">
              M
            </h2>
            <div className="max-w-2xl mx-auto space-y-2">
              <p className="text-sm md:text-base font-semibold text-[var(--color-green-accent)] uppercase tracking-wider font-sans">
                Formerly Gut Performance
              </p>
              <p className="text-xl md:text-2xl text-foreground font-default">
                Restore the foundation of your health.
              </p>
            </div>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-16">
            {protocolSteps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                  <div className="mb-8 p-6 rounded-full bg-background shadow-sm border border-border/50 transition-transform duration-500 group-hover:scale-105 group-hover:shadow-md group-hover:border-[var(--color-green-accent)]">
                    <Icon strokeWidth={1} className="w-12 h-12 text-[var(--color-green-accent)]" />
                  </div>
                  <h3 className="text-2xl font-semibold mb-4 font-default text-foreground">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground font-sans leading-relaxed text-base md:text-lg">
                    {step.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}